import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { Constants } from '../../../providers/constants/constants';

import { throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiService {
  constants = Constants;

  constructor(
    public http: HttpClient,
  ) { }

  public handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, body was: ${error.error}`);
      if (error.status === 401) {
      }
    }
    return throwError('Algo malo sucedio; Por favor, inténtelo de nuevo o más tarde.');
  }

  makeTokenHeader(token: string, typeToken: string, tokenEmpresa: boolean) {
    if (tokenEmpresa) {
      return `${typeToken} ${new Date().getFullYear()} 618de4f264ab3c12d27dbbcb`;
    }
    return token ? `${typeToken} ${token}` : '';
  }

  getHttpHeaders(typeToken: string, tokenEmpresa: boolean) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.makeTokenHeader(
          localStorage.getItem(this.constants.localStorage.token) || '',
          typeToken,
          tokenEmpresa
        )
      })
    };
    return httpOptions;
  }

  get(path: string, apiUrl: string = environment.apiUrl, typeToken: string = 'Bearer', tokenEmpresa: boolean = false) {
    return this.http.get(apiUrl + path, this.getHttpHeaders(typeToken, tokenEmpresa));
  }

  post(path: string, entity: any, apiUrl: string = environment.apiUrl, typeToken: string = 'Bearer', tokenEmpresa: boolean = false) {
    return this.http.post(apiUrl + path, entity, this.getHttpHeaders(typeToken, tokenEmpresa));
  }

  put(path: string, entity: any, apiUrl: string = environment.apiUrl, typeToken: string = 'Bearer', tokenEmpresa: boolean = false) {
    return this.http.put(apiUrl + path, entity, this.getHttpHeaders(typeToken, tokenEmpresa));
  }

  delete(path: string, apiUrl: string = environment.apiUrl, typeToken: string = 'Bearer', tokenEmpresa: boolean = false) {
    return this.http.delete(apiUrl + path, this.getHttpHeaders(typeToken, tokenEmpresa));
  }
}
